export class SentenceItemDto {
  id: number;
  name: string;
  mode: string;
}
